import { useCallback, useState } from 'react'
import { useGetLotList } from 'src/hooks/api/lot'
import { LotDto } from 'src/dto/lot.dto'

export function useLots() {
  const [isLotModalOpen, setIsLotModalOpen] = useState(false)
  const [selectedLot, setSelectedLot] = useState<LotDto | null>(null)

  const { data: lots = [], isLoading, refetch: refetchLots } = useGetLotList()

  const handleOpenModal = useCallback((lot?: LotDto) => {
    setSelectedLot(lot || null)
    setIsLotModalOpen(true)
  }, [])

  const handleCloseModal = useCallback(() => {
    setSelectedLot(null)
    setIsLotModalOpen(false)
    refetchLots()
  }, [refetchLots])

  return {
    lots,
    isLoading,
    isLotModalOpen,
    selectedLot,
    handleOpenModal,
    handleCloseModal,
    refetchLots
  }
}
